import React from "react";
import { Box, Typography, Grid, Card, CardMedia, CardContent } from "@mui/material";

const products = [
  {
    name: "Honey",
    volume: "3 Kg",
    image: "https://i.postimg.cc/T1KQ5cDG/e228527d499c179ffc077dfe60047d12.png",
  },
  {
    name: "Pickles (Mango / Lime / Mixed Vegitables)",
    volume: "5 Kg",
    image: "https://i.postimg.cc/9QqC3f35/Screenshot-2025-01-29-125801-removebg-preview.png",
  },
  {
    name: "Olive Oil",
    volume: "5 L",
    image: "https://i.postimg.cc/ZKhV56qk/d7b2bffeca5f986f63f5bf9a0cc47963.png",
  },
  {
    name: "Jeerakasala rice",
    volume: "18 Kg",
    image: "https://i.postimg.cc/8cbW5JyD/cbdaea0682bc04e3aab7a919b95d194e.png",
  },
  {
    name: "Matta short grain",
    volume: "18 Kg",
    image: "https://i.postimg.cc/8cWynPTz/image-removebg-preview.png",
  },
  {
    name: "Olive Oil",
    volume: "4 L",
    image: "https://i.postimg.cc/pTRLd03h/39ade69c025ca2cdf74c8973cb0b158d.png",
  },
  {
    name: "Jaya Rice",
    volume: "18 Kg",
    image: "https://i.postimg.cc/rsLsxQmY/01992f9dfc7eea8cfdeeeebebb4b5638-removebg-preview.png",
  },
  {
    name: "Kuruva Rice",
    volume: "18 Kg",
    image: "https://i.postimg.cc/0NW7GRRX/b4c1f6a529771894769b7a1b8a323238-removebg-preview.png",
  },
 
  {
    name: "Ponni Rice",
    volume: "18 Kg",
    image: "https://i.postimg.cc/DZnP6d8m/e2f95e58979eff1b17fa663e2b65d771-removebg-preview.png",
  },
];

const FoodProductGrid = () => {
  return (
    <Box sx={{ padding: "2rem", backgroundColor: "#fff" }}>
      {/* Heading */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          color: "green",
          textAlign: "center",
          marginBottom: "2rem",
          fontFamily: '"Montserrat", sans-serif',
        }}
      >
        Our Products
      </Typography>

      {/* Product Grid */}
      <Grid container spacing={3}>
        {products.map((product, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: "12px",
                textAlign: "center",
                overflow: "hidden",
              }}
            >
              {/* Product Image */}
              <CardMedia
                component="img"
                image={product.image}
                alt={product.name}
                sx={{
                  height: "200px",
                  objectFit: "contain",
                  backgroundColor: "#E3EBD4",
                }}
              />
              {/* Product Details */}
              <CardContent sx={{ padding: "1rem", backgroundColor: "#98AF41" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "white" }}
                >
                  {product.name}
                </Typography>
                <Typography variant="body2" sx={{ color: "white" }}>
                  ({product.volume})
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FoodProductGrid;
